import { lazy, Suspense, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import SmoothScroll from "./components/SmoothScroll.jsx";
import PreviewBanner from "./components/PreviewBanner.jsx";
import Nav from "./components/Nav.jsx";
import Footer from "./components/Footer.jsx";
import Breadcrumbs from "./components/Breadcrumbs.jsx";

const Home = lazy(() => import("./pages/Home.jsx"));
const Services = lazy(() => import("./pages/Services.jsx"));
const Technology = lazy(() => import("./pages/Technology.jsx"));
const About = lazy(() => import("./pages/About.jsx"));
const Quote = lazy(() => import("./pages/Quote.jsx"));
const FAQ = lazy(() => import("./pages/FAQ.jsx"));

// Bridge for the voice agent (public/js/agent-voice.js): exposes react-router
// navigation so the agent's open_page tool changes routes WITHOUT unloading
// the page (the voice session survives), and announces route changes so the
// agent drops its halo when the old page's elements unmount.
function AgentBridge() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    window.__agentNavigate = (to) => navigate(to);
    return () => { delete window.__agentNavigate; };
  }, [navigate]);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("agent:navigated", { detail: { path: pathname } }));
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <SmoothScroll>
      <AgentBridge />
      <PreviewBanner />
      <Nav />
      <main>
        <Breadcrumbs />
        <Suspense fallback={<div className="route-fallback" aria-hidden="true" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/about" element={<About />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </SmoothScroll>
  );
}
